import { escapeHTML } from '@lumapps/utils/string/escapeHTML';
import { CODE_BLOCK } from '@lumapps/wrex-code-block/constants';
import type { HTMLSerializeOptions } from '@lumapps/wrex/serialization/html/toHTML/types';

import { DIVIDER, INLINE_CODE, PARAGRAPH } from '../../constants';
import type { HeadingElement, ParagraphElement } from '../../types';

function alignmentAttr(alignment?: string): string {
    return alignment ? ` style="text-align:${escapeHTML(alignment)}"` : '';
}

export const TYPOGRAPHY_MARKS: HTMLSerializeOptions['marks'] = {
    bold: (children) => `<strong>${children}</strong>`,
    italic: (children) => `<em>${children}</em>`,
    underline: (children) => `<u>${children}</u>`,
    strikethrough: (children) => `<s>${children}</s>`,
    color: (children, value) =>
        value ? `<span style="color:${escapeHTML(String(value))}">${children}</span>` : children,
};

export const TYPOGRAPHY_ELEMENTS: HTMLSerializeOptions['elements'] = {
    headline: (node: ParagraphElement, children) => `<h1${alignmentAttr(node.alignment)}>${children}</h1>`,
    title: (node: ParagraphElement, children) => `<h2${alignmentAttr(node.alignment)}>${children}</h2>`,
    subtitle: (node: ParagraphElement, children) => `<h3${alignmentAttr(node.alignment)}>${children}</h3>`,
    heading: (node: HeadingElement, children) => {
        const level = typeof node.level === 'number' && node.level >= 1 && node.level <= 6 ? node.level : 2;
        return `<h${level}${alignmentAttr(node.alignment)}>${children}</h${level}>`;
    },
    [PARAGRAPH]: (node: ParagraphElement, children) => `<p${alignmentAttr(node.alignment)}>${children}</p>`,
    [CODE_BLOCK]: (_, children) => `<pre><code>${children}</code></pre>`,
    [INLINE_CODE]: (_, children) => `<code>${children}</code>`,
    [DIVIDER]: () => '<hr/>',
};
